<!-- Search Bar from Tablet or Desktop header -->
@if (isDesktop && layout === layoutVariation.header) {
<ng-container *ngTemplateOutlet="searchControl"></ng-container>
<div
  class="searchbar-wrapper"
  (focusout)="searchWrapperFocusOut($event)"
  tabindex="-1"
>
  <div
    id="searchOverlay"
    class="overlay overlay-left search-bar dynamic-header-height-top"
    [ngClass]="{
      'd-none': !isOpened
    }"
  >
    <div class="overlay-content">
      <div class="search-section">
        <ng-container *ngTemplateOutlet="searchBar"></ng-container>
      </div>
    </div>
  </div>
</div>
}
<!-- Search Bar from Mobile header -->
@if (!isDesktop && layout === layoutVariation.header) {
<ng-container *ngTemplateOutlet="searchControl"></ng-container>
<div
  id="searchBackdrop"
  class="overlay-content-backdrop sidenav-backdrop"
  [ngClass]="{
    'd-none': !isOpened
  }"
></div>
<div
  id="searchOverlay"
  class="overlay overlay-right sidenav-wrapper search-overlay"
  [ngClass]="{
    'd-none': !isOpened
  }"
>
  <div class="overlay-content">
    <div class="head-section">
      <button
        #elemFocus
        href="javascript:void(0)"
        class="close-btn"
        (click)="close()"
        type="button"
        [attr.data-automation]="'navigation_CloseSearch'"
        [attr.aria-label]="'close_button' | content"
      >
        <span class="sr-only">{{ "close_button" | content }}</span>
        <i class="cm-icons-close" aria-hidden="true"></i>
      </button>
    </div>
    <div class="body-section">
      <ng-container *ngTemplateOutlet="searchBar"></ng-container>
    </div>
  </div>
</div>
}

<!-- Common template of search contol -->
<ng-template #searchControl>
  <div class="search-wrapper">
    <button
      id="searchControl"
      (click)="isOpened ? close() : open()"
      class="search-icon cm-icons cm-icons-search"
      [ngClass]="{ 'search-icon-active': isOpened }"
      [attr.aria-expanded]="isOpened"
      [attr.aria-controls]="'searchOverlay'"
      [attr.data-automation]="'search-overlay'"
    >
      <span class="sr-only">{{ "lbl_header_search" | content }}</span>
    </button>
  </div>
</ng-template>

<ng-template #searchBar>
  <div
    class="search-box-dropdown"
    [ngClass]="{
      'mobile-wrapper': !isDesktop && layout === layoutVariation.header,
      'header-search': layout === layoutVariation.header
    }"
    [attr.data-automation]="'search'"
  >
    <ng-container *ngTemplateOutlet="defaultForm"></ng-container>
  </div>
</ng-template>

@if (layout === layoutVariation.dashboard) {
<div class="search-box-dasboard">
  <ng-container *ngTemplateOutlet="defaultForm"></ng-container>
</div>
}
<ng-template #defaultForm>
  <form
    class="search-bar-form"
    [formGroup]="searchForm"
    (submit)="onSearchHandler()"
    data-automation="search-bar-form"
  >
    <div class="search-input-wrapper">
      <div class="search-input-child-wrapper">
        <app-input
          [control]="searchForm.get('searchInput')"
          [controlName]="'searchInput'"
          [label]="label"
          [idExtra]="layout.split(' ').join('')"
          [automationAttribute]="'search-input-' + layout.split(' ').join('')"
          [placeholderText]="placeholder"
          class="search-bar-input"
          [showClear]="true"
        >
        </app-input>
        @if (isSymphonyAccount) {
        <div class="input-more-info">
          <span
            id="search_input_label_dashboard_v1"
            class="multi-search-helper-text"
          >
            {{ "lbl_search_input_info" | content }}
            <span
              class="helper-text-underline"
              id="search_input_label_dashboard"
            >
              {{ "lbl_search_input_info_learn" | content }}
            </span>
          </span>
        </div>
        }
      </div>
    </div>
    <app-button
      text="lbl_select_search_placeholder"
      [color]="buttonType"
      [automationAttribute]="'search-button-' + layout.split(' ').join('')"
      [className]="className"
      (clickEvent)="onSearchHandler()"
      [hasIcon]="true"
      iconClassName="cm-icons-angle-right"
      [disabled]="isSearching"
      [showSpinner]="isSearching"
      [customStyle]="{ marginTop: '6px' }"
    />
  </form>
</ng-template>
